import React, { FC, useState, useMemo } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, useIonViewWillEnter, useIonViewDidLeave } from '@ionic/react'
import { UseHeader, ResultAlert, MktLoading, MktEmpty } from '@cps'
import { memberMobx, activityMobx } from '@mobxStore'
import ActivityApi from '@api/activity.api'
import MemberCardApi from '@api/memberCard.api'
import { format } from '@dt/fe-utils'
import { modalLayer, useHistoryNew, toast } from '@utils'
import mktController from 'controllers/mktController'
import i18n from 'i18next'
import './index.scss'

interface IProps extends IPage, RouteComponentProps { }

const ConsumeRebate: FC<IProps> = ({ match }) => {
  const { activityId } = match.params as any
  const history = useHistoryNew()
  const [activeStatus, setActiveStatus] = useState<boolean>(true)
  const [activeInfo, setActiveInfo] = useState<any>({})
  const [showLoading, setShowLoading] = useState<boolean>(true)
  const [cardInfo, setCardInfo] = useState<any>({})
  const [partInNum, setPartInNum] = useState<number>(0)
  const { cardList, isLogin, isMember, getMemberCards } = memberMobx
  const { getActiveDetail } = activityMobx
  let clickType: boolean = true
  // Component Event
  const onBack = () => {
    mktController.goBack(history)
  }
  const showReward = () => {
    modalLayer(ResultAlert, {
      btnTitle: i18n.t('mkt.activity.goMenu'),
      des: i18n.t('mkt.activity.getCardDesc'),
      children: (
        <>
          <i className='iconfont icon-title icon-tab-my1'></i>
          <div className='end-title'>{i18n.t('mkt.activity.getCardSucc')}</div>
        </>
      )
    }).then(() => {
      history.push('/menu')
    }, () => { })
  }
  const getNewCard = () => {
    mktController.checkLogin(history).then(() => {
      if (ifCard) {
        history.push('/menu')
      } else {
        if (cardInfo.type === 'paid') {
          history.push(`/iCard/cardOpen/open/${cardInfo.cardId}`)
        } else {
          getCard()
        }
      }
    })
  }
  // Data Method
  const getActiveData = () => {
    getActiveDetail(activityId).then((res: any) => {
      setShowLoading(false)
      if (res) {
        setActiveInfo(res)
        if (res?.isOver) {
          setActiveStatus(false)
        } else {
          if (res.cards && res.cards.length > 0 && !cardInfo.cardId) {
            MemberCardApi.getAllLevelCardList({
              cardIds: res.cards,
            }).then((res) => setCardInfo(res[0]))
          }
        }
      } else {
        setActiveStatus(false)
      }
    })
  }
  const getPartInNum = () => {
    ActivityApi.getPartInNum({ brandId: memberMobx.brandId, activityId: activityId }).then((res: any) => {
      setPartInNum(res || 0)
    })
  }
  const getCard = () => {
    if (!clickType) return
    clickType = false
    memberMobx.acquireMemberCard(cardInfo.cardId).then((res: any) => {
      clickType = true
      if (res.error) {
        toast({ message: i18n.t('mkt.coupon.getFail') })
      } else {
        showReward()
      }
    })
  }
  const ifCard = useMemo(() => {
    return cardList.some(item => item.cardId === cardInfo.cardId)
  }, [cardList, cardInfo])
  // Component Effect
  useIonViewWillEnter(() => {
    setShowLoading(true)
    getActiveData()
    getMemberCards()
    if (memberMobx.isLogin) {
      getPartInNum()
    }
  })
  useIonViewDidLeave(() => {
    setShowLoading(false)
  }, [])
  return (
    <IonPage className='consume-rebate-page'>
      <UseHeader title={activeInfo.activityName} onBack={onBack}></UseHeader>
      <IonContent className='page-content'>
        {showLoading
          ? <MktLoading></MktLoading>
          : (
            <div className='page-body'>
              {activeInfo.playbill && <img className='activity-img' src={activeInfo.playbill} />}
              {
                activeStatus && activeInfo.extra ? (
                  <div className={`activity-info ${activeInfo.playbill ? 'activity-info-top' : ''}`}>
                    <div className='card-info'>
                      {
                        cardInfo.cardId &&
                          <div
                            className='get-card-face' style={{
                              color: (cardInfo.extra || {}).fontColor || '#f0cda8',
                              borderRightColor: (cardInfo.extra || {}).fontColor || '#f0cda8'
                            }}
                          >
                            <div
                              className='mci-content'
                              style={cardInfo.cover ? {
                                backgroundImage: `Url(${cardInfo.cover})`
                              } : { backgroundColor: '#251E1E' }}
                            >
                              <div className='mci-content-l'>
                                <div className='name'>{cardInfo.cardName}</div>
                                <div className='legal-right'>
                                  {cardInfo.allowAgainLoad || cardInfo.allowCustomizeLoad ? <span>{i18n.t('mkt.member.allowRe')}</span> : ''}
                                  {cardInfo.isIntegral && <span>{i18n.t('mkt.member.integralGet')}</span>}
                                  {cardInfo.discountType === 'memberPrice' &&
                                    <span>{i18n.t('mkt.common.equity')} {i18n.t('checkout.memberPrice')}</span>}
                                  {
                                    cardInfo.discountType === 'discountRate' &&
                                      <span>{i18n.t('mkt.common.equity')} {format.toDiscount('discountRate', cardInfo.discountValue)}</span>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                      }
                      <div className='card-btn' onClick={getNewCard}>
                        {
                          !isLogin
                            ? <span>{i18n.t('mkt.activity.registerCard')}</span>
                            : (
                              <span>
                                {ifCard ? i18n.t('mkt.activity.goMenu') : i18n.t('mkt.activity.getCard')}
                              </span>)
                        }
                      </div>
                      {
                        isMember &&
                          <div className='partin-num'>
                            {activeInfo.extra.consumeRebateType === 'consumeMonth' && activeInfo.extra.participateNum && i18n.t('mkt.activity.partInNumMonth', { num: partInNum })}
                            {activeInfo.extra.consumeRebateType === 'consumeFirst' && partInNum === 0 && i18n.t('mkt.market.eventIsOver')}
                          </div>
                      }
                    </div>
                    {
                      activeInfo.extra.copywriting &&
                        <div className='detail-des'>
                          <div>{i18n.t('mkt.activity.introduce')}</div>
                          <div className='des'>{activeInfo.extra.copywriting}</div>
                        </div>
                    }
                    {
                      activeInfo.extra &&
                        <div className='detail-des'>
                          <div>{i18n.t('mkt.activity.activityRules')}</div>
                          <div className='info-area'>
                            <div className='info-item'>
                              <div className='left'>
                                {i18n.t('mkt.activity.activeType')}:
                              </div>
                              <div className='right'>
                                {i18n.t(`mkt.activity.${activeInfo.extra.consumeRebateType}`)}
                              </div>
                            </div>
                            <div className='info-item'>
                              <div className='left'>
                                {i18n.t('mkt.activity.consumeMode')}:
                              </div>
                              <div className='right'>
                                {i18n.t('mkt.activity.consumeModeText')}
                              </div>
                            </div>
                            <div className='info-item'>
                              <div className='left'>
                                {i18n.t('mkt.activity.payMode')}:
                              </div>
                              <div className='right'>
                                {i18n.t('mkt.activity.payModeText')}
                              </div>
                            </div>
                            <div className='info-item'>
                              <div className='left'>
                                {i18n.t('mkt.pointCard.member')}:
                              </div>
                              <div className='right'>
                                {cardInfo.cardName}
                              </div>
                            </div>
                            <div className='info-item'>
                              <div className='left'>
                                {i18n.t('mkt.activity.refundWay')}:
                              </div>
                              <div className='right'>
                                {i18n.t('mkt.activity.refundWayText')}
                              </div>
                            </div>
                            <div className='info-item'>
                              <div className='left'>
                                {i18n.t('mkt.activity.times')}:
                              </div>
                              <div className='right'>
                                {format.toDateTime(activeInfo.startTime)} ~ {format.toDateTime(activeInfo.endTime)}
                              </div>
                            </div>
                            <div className='info-item'>
                              <div className='left'></div>
                              <div className='right'>
                                {i18n.t('mkt.activity.activeTip')}
                              </div>
                            </div>
                          </div>
                        </div>
                    }
                  </div>
                ) : (
                  <div className='activity-end'>
                    <MktEmpty type='end' text={activeInfo?.activityId ? i18n.t('mkt.market.eventIsOver') : i18n.t('mkt.market.activityNotExist')}></MktEmpty>
                  </div>
                )
              }
            </div>
          )}
      </IonContent>
    </IonPage>
  )
}

export default observer(ConsumeRebate)
